
import {IconProps} from "../../types/IconProps";

export const QuestionIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg fill={color} width={`${width}px`} height={`${width}px`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             id="question" className="icon glyph">
            <path
                d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,16a1,1,0,1,1,1-1A1,1,0,0,1,12,18Zm1.71-4.61c-.71.34-.71.39-.71.61a1,1,0,0,1-2,0,2.6,2.6,0,0,1,1.84-2.42C13.61,11.21,14,11,14,10a1,1,0,0,0-.49-.86A2.82,2.82,0,0,0,12,8.75c-.69,0-2,.26-2,1.25a1,1,0,0,1-2,0c0-1.88,1.68-3.25,4-3.25S16,8.12,16,10A3.41,3.41,0,0,1,13.71,13.39Z"></path>
        </svg>
    )
}